module.exports = __webpack_public_path__ + "assets/img/wechat.28725df0.svg";